import { render, staticRenderFns } from "./ProductPriceAdjustment.vue?vue&type=template&id=b4337bcc&scoped=true&"
import script from "./ProductPriceAdjustment.vue?vue&type=script&lang=js&"
export * from "./ProductPriceAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceAdjustment.vue?vue&type=style&index=0&id=b4337bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4337bcc",
  null
  
)

export default component.exports